import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/visitsConstants';

const initialState = {
  visits: [],
  loading: true,
  pageable: {
    totalPages: 1,
    last: true,
    first: true,
    size: 0,
    number: 0,
    totalElements: 0,
  },
  search: {
    status: 'IN_PROGRESS',
    search: '',
    page: 0,
    size: 10,
  },
};

const visitsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_VISITS:
      return {
        ...initialState,
      };
    case types.GET_VISITS_SUCCESS:
      return {
        ...state,
        loading: false,
        visits: payload.data,
        pageable: payload.pageable,
      };
    case types.GET_VISITS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_VISITS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SET_VISITS_PAGE_SIZE:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          size: payload,
        },
      };
    case types.SET_VISITS_SEARCH:
      return {
        ...state,
        search: {
          ...state.search,
          search: payload,
        },
      };
    case types.SET_VISITS_STATUS:
      return {
        ...state,
        search: {
          ...state.search,
          status: payload,
        },
      };
    case types.NEXT_VISITS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page + 1,
        },
      };
    case types.PREV_VISITS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page - 1,
        },
      };
    default:
      return state;
  }
};

export default visitsReducer;
